<template>
  <!-- 客诉管理日志表 -->
  <div class="operatingRecord">
    <h1>客诉管理表日志表</h1>
    <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
      <el-table-column
          type="selection"
          width="55">
      </el-table-column>
      <el-table-column label="更新人" width="100px">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.userName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="更新时间" width="170px">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.updateTime|datefilter }}</span>
        </template>
      </el-table-column>
      <el-table-column label="问题来源" width="130px">
        <template slot-scope="scope">
          <span v-if="scope.row.sourceOfComplaint==1" style="margin-left: 10px">账号邮件</span>
          <span v-if="scope.row.sourceOfComplaint==2" style="margin-left: 10px">邮箱邮件</span>
          <span v-if="scope.row.sourceOfComplaint==3" style="margin-left: 10px">FB</span>
          <span v-if="scope.row.sourceOfComplaint==4" style="margin-left: 10px">退款订单</span>
          <span v-if="scope.row.sourceOfComplaint==5" style="margin-left: 10px">重发订单</span>
          <span v-if="scope.row.sourceOfComplaint==6" style="margin-left: 10px">差评</span>
        </template>
      </el-table-column>
      <el-table-column label="订单号" width="100px">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.amazonOrderId }}</span>
        </template>
      </el-table-column>
      <el-table-column label="客户姓名" width="100px">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.clientName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="客户邮箱" width="100px">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.clientMail }}</span>
        </template>
      </el-table-column>
      <el-table-column label="客户FB-ID" width="100px">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.buyerFb }}</span>
        </template>
      </el-table-column>
      <el-table-column label="卖家SKU" width="100px">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.msku }}</span>
        </template>
      </el-table-column>
      <el-table-column label="内部SKU" width="100px">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.psku }}</span>
        </template>
      </el-table-column>
      <el-table-column label="问题类型" width="130px">
        <template slot-scope="scope">
          <span v-if="scope.row.complaintType==1" style="margin-left: 10px">质量问题</span>
          <span v-if="scope.row.complaintType==2" style="margin-left: 10px">配件问题</span>
          <span v-if="scope.row.complaintType==3" style="margin-left: 10px">包装问题</span>
          <span v-if="scope.row.complaintType==4" style="margin-left: 10px">物流问题</span>
          <span v-if="scope.row.complaintType==5" style="margin-left: 10px">客户误操作</span>
          <span v-if="scope.row.complaintType==6" style="margin-left: 10px">客户取消订单</span>
          <span v-if="scope.row.complaintType==7" style="margin-left: 10px">客户无反馈</span>
          <span v-if="scope.row.complaintType==8" style="margin-left: 10px">亚马逊退货问题</span>
          <span v-if="scope.row.complaintType==9" style="margin-left: 10px">其他</span>
        </template>
      </el-table-column>
      <el-table-column label="购买时间" width="170px">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.purchaseDate|datefilter }}</span>
        </template>
      </el-table-column>
      <el-table-column label="具体问题" width="100px">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.detailedProblem }}</span>
        </template>
      </el-table-column>
      <el-table-column label="跟踪进度" width="170px">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.processingProgress }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="100px">
        <template slot-scope="scope">
          <span v-if="scope.row.status==1" style="margin-left: 10px">跟进中</span>
          <span v-else style="margin-left: 10px">已解决</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="250px">
        <template slot="header">
          <el-button size="small" type="primary" @click="$router.go(-1)">返回</el-button>
          <!-- 导入 -->
          <el-upload
              class="upload-demo"
              action="string"
              :limit="1"
              :before-upload="handleBeforeUpload"
              :http-request="husinessLicenseHandler"
              :show-file-list="false"
              ref="upload"
              :file-list="fileList">
            <el-button size="mini" type="success" :loading="uploadLoading">导入</el-button>
          </el-upload>
          <el-button type="warning" size="mini" @click="exportExcel()" :loading="downloadLoading">导出</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 添加分页器 -->
    <div class="block">
      <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="size"
          :page-sizes="[5, 10, 20,30,50,60,70,100]"
          layout="sizes,prev, pager, next,jumper"
          :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import {apiLogSheet, apiImportFile, apiOperationRecords} from "../../api/operatingRecord";

export default {
  data() {
    return {
      // apiRecordinfo
      AddDialogVisible: false,
      editDialogVisible: false,
      uploadLoading: false,
      downloadLoading: false,
      labelPosition: "right",
      //新增表单数据：
      searchBar: {},
      addForm: {},
      //编辑表单数据：
      editForm: {},
      //表格绑定数据
      //分页器数据
      currentPage: 1, //默认第一页 当前页
      size: 10,
      total: 0,//总条数
      formLabelAlign: {
        name: "",
        region: "",
        type: "",
      },
      tableData: [],
      fileList: [],
      complaintId: ''//传递的id
    };
  },

  methods: {
    handleSizeChange(size) {
      this.size = size;
      this.getOperatingList()
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getOperatingList()
    },
    //导入
    handleBeforeUpload(file) {//上传文件之前的钩子，参数为上传的文件
      if (file.name.indexOf("xls") === -1 && file.name.indexOf("xlsx") === -1) {
        this.$message.warning("上传模板只能是 xls、xlsx格式!");
        return false;
      }
    },
    // 成功
    husinessLicenseHandler(params) {//覆盖
      this.uploadLoading = true;
      const _file = params.file;
      var formData = new FormData()// 通过 FormData 对象上传文件
      formData.append('file', _file)
      apiImportFile(formData).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: res.data.message,
            type: 'success'
          });
          this.getOperatingList();
        } else {
          this.$message.error('导入失败');
        }
      }).finally(() => {
        this.fileList = [];
        this.uploadLoading = false;
      })
    },

    exportExcel() {
      this.downloadLoading = true;
      var fileName = "客诉管理表日志表.xlsx";
      apiLogSheet({
        q: JSON.stringify(this.searchBar),
        page: this.currentPage,
        size: this.size,
        sort: "id",
        direction: "DESC"
      }).then((res) => {
        if (res.status == 200) {
          const link = document.createElement('a')
          let blob = new Blob([res.data], {type: "application/vnd.ms-excel"})
          let objectUrl = URL.createObjectURL(blob) // 创建URL
          link.href = objectUrl
          link.download = fileName
          link.click()
          link.remove()
          URL.revokeObjectURL(objectUrl);
          // this.getRecordsList()
        }
      }).finally(() => {
        this.downloadLoading = false;
      })

    },
    //  获取全部数据
    getOperatingList() {
      this.searchBar = {};
      this.searchBar.complaintId = this.complaintId;
      this.searchBar = this.common.clearNull(this.searchBar);
      // 操作
      apiOperationRecords({
        q: JSON.stringify(this.searchBar),
        page: this.currentPage,
        size: this.size,
        sort: "id",
        direction: "DESC"
      }).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.rows;
          this.total = res.data.data.total
        }
      });
    }
  },
  created() {
    this.complaintId = this.$route.query.complaintId;
    this.getOperatingList()
  },
  //日期的格式化
  filters: {
    datefilter: function (value) {
      return moment(value).format("YYYY-MM-DD HH:mm:ss");
      //这里的日期格式可自定义
    },
  },
};
</script>

<style lang='less' scoped>
.operatingRecord {
  padding: 50px 30px;

  h1 {
    margin-bottom: 20px;
  }

  .el-pagination {
    padding: 32px 0px;
  }
}
</style>